import root from 'window-or-global';
import {GetAlertProps} from '../types';

export default function(props: GetAlertProps): VoidFunction {
    if (!props) return null;
    const {history, taxState, traceSecurityLink = () => {}, configState} = props || {};
    const {hyperWalletData} = taxState || {};

    if (hyperWalletData) {
        if (!hyperWalletData.linkEnable) {
            return () => root.open(configState.hyperWalletHomepage);
        } else if (hyperWalletData.link) {
            return () => {
                root.open(hyperWalletData.link);
                traceSecurityLink();
            };
        }
    }

    return () => history.push('settings');
}
